import { ComponentProps } from "../registry";
import { useBound, writePath } from "../helpers";
import { BoundString, BoundValue } from "../../types";

export function DateTimeInput({ fields, scope }: ComponentProps) {
  const value = useBound<string>(fields.value as BoundValue, scope) ?? "";
  const enableDate = useBound<boolean>(fields.enableDate as BoundValue, scope) ?? true;
  const enableTime = useBound<boolean>(fields.enableTime as BoundValue, scope) ?? false;
  const path = (fields.value as BoundString | undefined)?.path;

  const inputType =
    enableDate && enableTime ? "datetime-local" :
    enableTime               ? "time" :
                               "date";

  return (
    <input
      className="a2-field-input"
      type={inputType}
      value={value}
      onChange={(e) => path && writePath(path, e.target.value)}
    />
  );
}
